import { ENTITY_CONSTANTS } from '../../../constants/entityConstants';

export function getSentenceKey(
    type: string,
    contextTerm: string | null,
    label: string | null,
    hasCreatedBy: boolean
): string {
    if (type === ENTITY_CONSTANTS.production) {
        // No name and no context - only label
        if (!hasCreatedBy && !contextTerm && label) {
            return 'person.engagement.information.production.noNameAndContext';
        }
        // Has label and name but no context
        if (!contextTerm && label && hasCreatedBy) {
            return 'person.engagement.information.production.noContext';
        }
        // Has label and context but no name
        if (!hasCreatedBy && contextTerm && label) {
            return 'person.engagement.information.production.noName';
        }
        // Has context and name but no label
        if (!label && contextTerm && hasCreatedBy) {
            return 'person.engagement.information.production.withContext';
        }
        // Has all three: label, context, and name
        return 'person.engagement.information.production.noProduction';
    }
    if (type === ENTITY_CONSTANTS.shortlistLineitem) {
        // No name and no context - only label
        if (!hasCreatedBy && label) {
            return 'person.engagement.information.shortlistLineItem.noName';
        }
        // Has label and name but no context
        if (!label && hasCreatedBy) {
            return 'person.engagement.information.shortlistLineItem.noLabel';
        }
        // Has label and name
        return 'person.engagement.information.shortlistLineItem';
    }
    if (!hasCreatedBy) {
        return 'person.engagement.information.note.noName';
    }

    return contextTerm
        ? 'person.engagement.information.note.withContext'
        : 'person.engagement.information.note.noContext';
}
